// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  Modifier,
  RichUtils,
  EditorState,
  convertToRaw,
  ContentState,
} from "draft-js";
import createToolbarPlugin from "draft-js-static-toolbar-plugin";
import { cloneDeep, range } from "lodash";
import uuid from "react-native-uuid";
import { Toastr } from "../../revvComponents";
import getCompositeDecorator from "../CustomRevvEditor/decorator";

// Components Imports
import RevvToolBar from "../RevvToolBar";
import RevvTableToolBar from "../RevvTableToolBar";
import HyperlinkBox from "../DocumentItems/HyperlinkBox";
import applyFontStyle from "./applyFontStyle";
import ManageColumnsPopup from "../DocumentItems/ManageColumnsPopup";
import EditTableApiHeaderPopup from "../DocumentItems/EditTableApiHeaderPopup";
import MergeCellConfirmation from "../RevvTableV2/TableOptions/Buttons/MergeCellsBtn/MergeCellConfirmation";

// Actions Imports
import { EditorActions, NotesActions } from "../../actions";
import {
  changeToolsView,
  preventEditorToDeactivate,
  handleCustomColorDropDownOpen,
  updateDocMeta,
  updateComponentEditorState,
  executeCommand,
  updateDynamicFieldsInDoc,
  updateDynamicFieldsInMasterDoc,
  updateDocumentComponentAction,
  updateComponentMeta,
  updateEditorStateInSectionForClauseOptions,
  updateDocumentClickedComponentID,
  tableSelectionTypeAction,
} from "../../actions/DocumentActions/index";
import {
  updateTableAPICellData,
  updateTableAPIColData,
} from "../../actions/TableFieldActions/index";
import {
  getComponentFromInfo,
  // getComponentEditorState,
  emptyTextEditor,
  selectAllEditorText,
  removeSelection,
} from "../../utils/documentUtils";
// command import
import FormFieldCommand from "../../commands/formFieldCommand";
import UpdateEditorFromToolbarCommand from "../../commands/updateEditorFromToolbarCommand";

import { updateTemplateMeta } from "../../actions/DocumentTemplateActions/templateActions";

// Methods Imports
import {
  isEditableTextAreaCOEditor,
  isEditableRevvComponent,
} from "../DocumentItems/methods";

// Internal Imports
import {
  setBlockType,
  setBlockData,
  toggleBlockIndent,
  updateSelectionForEntity,
  applyHeaderToSelection,
  toggleBold,
  addInlineStyleToCurrentBlock,
  getClosestFontWeightStyle,
  applyMarginLeft,
  handleHeaderToListStyles,
} from "../../utils/draftUtils";
import { emptyNote } from "../Notes/utils";
import { getCellData, isTableCellMerged } from "../RevvTableV2/utils";
import { DOCUMENTS } from "../../constants";
import { findClosestSize } from "../../constants/fontSizes";
import "draft-js-static-toolbar-plugin/lib/plugin.css";
import { DOCUMENT_MODE } from "../../constants/document";

import { GlobalUtils } from "../../utils";

const { readDataFromLocalStorage } = GlobalUtils;

// Destructuring
const { FONT_SIZE_OPTIONS, HEADER_FONT_SIZES, DOCUMENT_COMPONENT_TYPES } =
  DOCUMENTS;
const {
  updateActiveEditorState,
  updateEditorHighlightSelection,
  forceUpdateLocalEditorState,
  initActiveEditor,
  nukeActiveEditor,
} = EditorActions;
const { addNote } = NotesActions;
const staticToolbarPlugin = createToolbarPlugin();
const { Toolbar } = staticToolbarPlugin;

const ALIGNMENT_MAP = {
  center: "center",
  left: "flex-start",
  right: "flex-end",
};

/**
 * :::===::: CustomRevvToolbar :::===:::
 * This component will be used for two scenarios,
 * 1. When both the Text Editor and the Toolbar come separatly(ex: Custom Text and Custom Table Text),
 * 2. When both the Text Editor and the Toolbar come together(ex: Add Clause Option and Form mode doc text area)
 */
class CustomRevvToolbar extends Component {
  state = {
    showHyperlinkBoxConfirmation: false,
    tempEditorState: null,
    tempCurrentSection: null,
    activeToolbarDropDown: null,
    columnsHeaders: [],
    showManageColumnPopup: false,
    showMergeCellConfirmation: false,
    hiddenColumnsForGsheet:
      this.props.component &&
      this.props.component.data &&
      this.props.component.data.attributes &&
      (this.props.component.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET ||
        this.props.component.type === DOCUMENT_COMPONENT_TYPES.TABLE ||
        this.props.component.data.attributes.showManageColumnOption) &&
      this.props.component.data.attributes.hiddenCols
        ? this.props.component.data.attributes.hiddenCols
        : [],
    tempCurrentActiveComponentMeta: null,
    showEditHeaderPopupTableApi: false,
  };

  componentDidMount() {
    if (
      this.props.component &&
      this.props.component.data &&
      this.props.component.data.attributes &&
      this.props.component.data.attributes.hiddenCols
    ) {
      this.setState({
        hiddenColumnsForGsheet: this.props.component.data.attributes.hiddenCols,
      });
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevState.activeToolbarDropDown === "FONT_COLOR" &&
      this.state.activeToolbarDropDown !== "FONT_COLOR"
    ) {
      this.props.handleCustomColorDropDownOpen(false, true);
    }
  };

  _getEditorState = () => {
    const { isSeparateToolbar, localEditorState } = this.props;
    if (isSeparateToolbar) {
      return this.props.activeEditorState;
    }
    return localEditorState;
  };
  // _getEditorState = () => {
  //   const { isSeparateToolbar, localEditorState } = this.props;
  //   if (isSeparateToolbar) {
  //     return this.props.editorState;
  //   }
  //   return localEditorState;
  // };

  _toogleToolbarDropDown = type => {
    this.setState({
      activeToolbarDropDown: type,
    });
  };

  _onChange = editorState => {
    const { activeComponent } = this.props;
    if (
      activeComponent &&
      activeComponent.componentMeta &&
      activeComponent.componentMeta.componentType ===
        DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER
    ) {
      const newEditorState = removeSelection(editorState);
      const updateEditorFromToolbarCommand = new UpdateEditorFromToolbarCommand(
        {
          componentMeta: activeComponent.componentMeta,
          editorState: newEditorState,
          mode: this.props.mode,
          section: this.props.activeComponent,
          updateComponentEditorState: this.props.updateComponentEditorState,
          updateSection: this.props.updateSection,
          oldEditorState: this.props.activeEditorState,
          updateActiveEditorState: this.props.updateActiveEditorState,
        },
      );
      this.props.executeCommand(updateEditorFromToolbarCommand);
    } else if (this.props.isSeparateToolbar) {
      if (this.props.isEditableTextAreaClauseOptionEditor) {
        this.props.updateActiveEditorState(
          editorState,
          this.props.activeComponentMeta,
        );
        this._updateTextAreaClauseOptionInDoc(
          editorState,
          this.props.activeEditorState,
        );
        // this.props.updateComponentEditorState({
        //   componentMeta: this.props.activeComponentMeta,
        //   editorState,
        //   mode: this.props.mode,
        // });
      } else {
        let isUnlinkedTableAPICell = false;

        if (activeComponent.type === "Table" && activeComponent.clauseOptions) {
          const {
            attributes: { dataSource, isUnlinkedTableAPI },
          } = activeComponent.data;
          if (dataSource === "TableApi" && isUnlinkedTableAPI) {
            isUnlinkedTableAPICell = true;
          }
        }

        if (isUnlinkedTableAPICell) {
          this._saveUnlinkedTableAPICellData(editorState);
        } else {
          const updateEditorFromToolbarCommand =
            new UpdateEditorFromToolbarCommand({
              componentMeta: this.props.activeComponentMeta,
              editorState,
              mode: this.props.mode,
              section: this.props.activeComponent,
              updateComponentEditorState: this.props.updateComponentEditorState,
              updateActiveEditorState: this.props.updateActiveEditorState,
              updateSection: this.props.updateSection,
              oldEditorState: this.props.activeEditorState,
            });
          this.props.executeCommand(updateEditorFromToolbarCommand);
        }
      }
    } else {
      this.props.updateLocalEditorState(editorState);
    }
  };

  _saveUnlinkedTableAPICellData = (
    editorState,
    cellMeta,
    text,
    rich,
    component,
    componentMeta,
    isTableAPIHeaderCellBgColourChange,
  ) => {
    const activeComponent = this.props.activeComponent || component;
    const activeComponentMeta =
      this.props.activeComponentMeta &&
      Object.keys(this.props.activeComponentMeta).length > 0
        ? this.props.activeComponentMeta
        : componentMeta;
    let editorTextValue;
    if (text === "" || text) {
      editorTextValue = text;
    } else {
      editorTextValue = editorState.getCurrentContent().getPlainText("\u0001");
    }
    const {
      attributes: { tableAPIFieldId, isUnlinkedTableDocument },
    } = activeComponent.data;
    const { tableCellId, tableRowId } = activeComponentMeta;
    const [rowId, cellId] = tableCellId ? tableCellId.split("_") : [null, null];
    const data = {
      tableFieldId: tableAPIFieldId,
      text: editorTextValue,
      rich:
        rich ||
        (editorState ? convertToRaw(editorState.getCurrentContent()) : ""),
      rowId,
      cellId:
        (isUnlinkedTableDocument && tableRowId === 0) ||
        isTableAPIHeaderCellBgColourChange
          ? rowId
          : cellId,
    };

    const updateTableAPICell =
      (isUnlinkedTableDocument && tableRowId === 0) ||
      isTableAPIHeaderCellBgColourChange
        ? this.props.updateTableAPIColData
        : this.props.updateTableAPICellData;

    if (cellMeta) {
      data.cellMeta = cellMeta;
    } else {
      let unlinkedTableData;
      this.props.tablesUsed.forEach(table => {
        if (table.table_id === tableAPIFieldId) {
          unlinkedTableData = table;
        }
      });
      const { table_rows: tableRows } = unlinkedTableData;
      let cellData = {};
      tableRows.forEach(tableRow => {
        if (tableRow.row_id === rowId) {
          cellData = tableRow.row_data[cellId];
        }
      });
      if (cellData.cell_meta) {
        data.cellMeta = cellData.cell_meta;
      }
    }
    updateTableAPICell(data)
      .then(() => {})
      .catch(error => {
        console.error(
          "CustomRevvToolbar => _saveUnlinkedTableAPICellData => Error",
          error,
        );
      });

    this.props.updateActiveEditorState(editorState, activeComponentMeta);
    //   if (this.props.activeComponentMeta.blockType === "BODY") {
    //     this.props.updateSection(
    //       updatedSection,
    //       true,
    //       false,
    //       oldSection,
    //       false,
    //       null,
    //       false,
    //       componentMeta,
    //     );
    //   }
  };

  _updateTextAreaClauseOptionInDoc = (editorState, oldEditorState) => {
    let value = null;
    let oldValue = null;
    const oldEditorText = oldEditorState
      .getCurrentContent()
      .getPlainText("\u0001");
    if (oldEditorText) {
      oldValue = {
        value: JSON.stringify(convertToRaw(oldEditorState.getCurrentContent())),
      };
    }
    const editorText = editorState.getCurrentContent().getPlainText("\u0001");
    if (editorText) {
      value = {
        value: JSON.stringify(convertToRaw(editorState.getCurrentContent())),
      };
    }

    const { sharingHash, newMasterDocUrl } = this.props.match.params;
    const { id, filler_type: fillerType } = this.props.clauseOptionsDetails;
    if (newMasterDocUrl) {
      // Not a promise : updating redux only
      const formFieldCommand = new FormFieldCommand({
        updateDynamicFieldsInMasterDoc:
          this.props.updateDynamicFieldsInMasterDoc,
        updateDynamicFieldsInDoc: this.props.updateDynamicFieldsInDoc,
        forceUpdateLocalEditorState: this.props.forceUpdateLocalEditorState,
        updateEditorStateInSectionForClauseOptions:
          this.props.updateEditorStateInSectionForClauseOptions,
        payload: {
          id,
          value,
          oldValue,
          doctype: "MASTERDOC",
          updateFromComponent: true,
          section: this.props.activeComponent,
          componentMeta: this.props.activeComponentMeta,
        },
      });
      this.props.executeCommand(formFieldCommand);
      // this.props.updateDynamicFieldsInMasterDoc(id, value, true);
    } else if (sharingHash) {
      const formFieldCommand = new FormFieldCommand({
        updateDynamicFieldsInMasterDoc:
          this.props.updateDynamicFieldsInMasterDoc,
        updateDynamicFieldsInDoc: this.props.updateDynamicFieldsInDoc,
        forceUpdateLocalEditorState: this.props.forceUpdateLocalEditorState,
        updateEditorStateInSectionForClauseOptions:
          this.props.updateEditorStateInSectionForClauseOptions,
        payload: {
          id,
          value,
          isShared: true,
          sharingHash,
          fillerType,
          oldValue,
          type: "CLAUSE",
          updateFromComponent: true,
          section: this.props.activeComponent,
          componentMeta: this.props.activeComponentMeta,
        },
      });
      this.props.executeCommand(formFieldCommand);
    } else {
      const formFieldCommand = new FormFieldCommand({
        updateDynamicFieldsInMasterDoc:
          this.props.updateDynamicFieldsInMasterDoc,
        updateDynamicFieldsInDoc: this.props.updateDynamicFieldsInDoc,
        forceUpdateLocalEditorState: this.props.forceUpdateLocalEditorState,
        updateEditorStateInSectionForClauseOptions:
          this.props.updateEditorStateInSectionForClauseOptions,
        payload: {
          id,
          value,
          isShared: false,
          sharingHash: null,
          fillerType,
          oldValue,
          type: "CLAUSE",
          updateFromComponent: true,
          section: this.props.activeComponent,
          componentMeta: this.props.activeComponentMeta,
        },
      });
      this.props.executeCommand(formFieldCommand);
    }
  };

  _handleChange = newEditorState => {
    this._onChange(newEditorState);
  };

  _setBlockType = blockType => {
    const editorState = this._getEditorState();
    let newEditorState = editorState;
    const currentFocus = editorState.getSelection().getFocusKey();
    const inlineStyle = editorState.getCurrentInlineStyle(currentFocus);
    let fontSizeName;

    if (blockType === "unstyled") {
      // Default Font size for unstyled block
      fontSizeName = "FONTSIZE_FOURTEEN";
    }

    // in case of header remove font size & apply correct one
    if (
      blockType === "header-one" ||
      blockType === "header-two" ||
      blockType === "header-three" ||
      blockType === "header-four"
    ) {
      const fontSize = findClosestSize(HEADER_FONT_SIZES[blockType]);
      newEditorState = addInlineStyleToCurrentBlock(
        editorState,
        fontSize.name,
        ["FONTSIZE"],
      );
      fontSizeName = fontSize.name;
    }

    if (inlineStyle.size > 0) {
      if (
        blockType === "header-one" ||
        blockType === "header-two" ||
        blockType === "header-three" ||
        blockType === "header-four"
      ) {
        newEditorState = applyHeaderToSelection(newEditorState, blockType);
      } else {
        const nextContentState = Object.keys(FONT_SIZE_OPTIONS).reduce(
          (contentState, size) =>
            Modifier.removeInlineStyle(
              contentState,
              editorState.getSelection(),
              size,
            ),
          editorState.getCurrentContent(),
        );

        const nextEditorState = EditorState.push(
          editorState,
          nextContentState,
          "change-inline-style",
        );
        newEditorState = setBlockType(blockType, nextEditorState);
      }
    } else {
      newEditorState = setBlockType(blockType, newEditorState);
    }
    const metadata = [
      {
        op: "replace",
        field: "meta_data",
        value: {
          meta_data: {
            ...this.props.metaData,
            FONTSIZE: fontSizeName,
            BLOCKTYPE: blockType,
          },
        },
      },
    ];
    this._saveMetaData(metadata);
    this._handleChange(newEditorState);
  };

  _setBlockTypeNormal = () => {
    this._setBlockType("unstyled");
  };

  _handleHeaderButton = buttonType => {
    this._setBlockType(buttonType);
  };

  _handleAlignmentLineHeight = (style, type) => {
    const editorState = this._getEditorState();
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    let updatedContentState = contentState;

    // check if there is any selection or not
    if (selectionState.isCollapsed()) {
      // if there is no selection, just toggle alignment
      const blockKey = selectionState.getAnchorKey();
      updatedContentState = this._toggleBlockAlignmentLineHeight(
        style,
        type,
        updatedContentState,
        blockKey,
      );
    } else {
      // if there is any selection, update the alignment
      // for each block under selection
      // get the start key
      let startKey = selectionState.getStartKey();
      // and update till endKey
      const endKey = contentState.getKeyAfter(selectionState.getEndKey());
      while (startKey !== endKey) {
        // check if block type is list: disable if so
        updatedContentState = this._toggleBlockAlignmentLineHeight(
          style,
          type,
          updatedContentState,
          startKey,
        );
        startKey = contentState.getKeyAfter(startKey);
      }
    }

    // set the new editor state
    const updatedEditorState = EditorState.set(editorState, {
      currentContent: updatedContentState,
    });
    this._handleChange(updatedEditorState);
  };

  _toggleBlockAlignmentLineHeight = (
    appliedStyle,
    type,
    contentState,
    blockKey,
  ) => {
    // get the block
    const block = contentState.getBlockForKey(blockKey);
    // get block data
    let blockData = block.data;
    // get element style of the block, if any
    const elementStyle = blockData.get("elementStyle");
    // get all the styles
    const styles =
      typeof elementStyle === "string" ? elementStyle.split(";") : [];

    /**
     * :: Alignment for List Items ::
     * here, "text-align" - "left", "center" and "right" will not work for list items
     * so need to add the "justify-content" - "flex-start", "center" and "flex-end" to get the
     * expected alignment
     *
     * NOTE :: in case of "text-align:justify", need to remove the "justify-content:*"
     */
    const isListBlock = !!block.type.includes("list");
    const justifyContentIndex = styles.findIndex(style =>
      style.startsWith("justify-content"),
    );
    const lineheightIndex = styles.findIndex(style =>
      style.startsWith("line-height"),
    );
    if (lineheightIndex > -1) {
      styles.splice(lineheightIndex, 1);
    }
    if (isListBlock) {
      if (justifyContentIndex > -1) {
        if (type === "justify") {
          styles.splice(justifyContentIndex, 1);
        } else {
          styles[
            justifyContentIndex
          ] = `justify-content:${ALIGNMENT_MAP[type]}`;
        }
      } else if (type !== "justify") {
        styles.push(`justify-content:${ALIGNMENT_MAP[type]}`);
      }
    } else if (justifyContentIndex > -1) {
      styles.splice(justifyContentIndex, 1);
    }

    let filterStyles = styles;
    if (appliedStyle === "AlignButtons") {
      filterStyles = styles.filter(style => !style.startsWith("text-align"));
    }
    if (appliedStyle === "LineHeight") {
      filterStyles.push(`line-height:${type}`);
    } else if (appliedStyle === "AlignButtons") {
      filterStyles.push(`text-align:${type}`);
    }

    // update block data
    blockData = blockData.set("elementStyle", filterStyles.join(";"));

    // set new block data to the block
    const updatedContentState = setBlockData(blockData, contentState, blockKey);
    return updatedContentState;
  };

  _handleIndent = type => {
    const editorState = this._getEditorState();
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    let updatedContentState = contentState;

    // check if there is any selection or not
    if (selectionState.isCollapsed()) {
      // if there is no selection, just toggle alignment
      const blockKey = selectionState.getAnchorKey();
      updatedContentState = toggleBlockIndent(
        type,
        updatedContentState,
        blockKey,
      );
    } else {
      // if there is any selection, update the alignment
      // for each block under selection
      // get the start key
      let startKey = selectionState.getStartKey();
      // and update till endKey
      const endKey = contentState.getKeyAfter(selectionState.getEndKey());
      while (startKey !== endKey) {
        updatedContentState = toggleBlockIndent(
          type,
          updatedContentState,
          startKey,
        );
        startKey = contentState.getKeyAfter(startKey);
      }
    }

    // set the new editor state
    const updatedEditorState = EditorState.set(editorState, {
      currentContent: updatedContentState,
    });
    this._handleChange(updatedEditorState);
  };

  _handleListButton = (newListType, prevListType, marginLeft) => {
    const editorState = this._getEditorState();
    let updatedEditorState = setBlockType(
      newListType,
      editorState,
      prevListType,
    );
    if (newListType === "unstyled" && marginLeft) {
      updatedEditorState = applyMarginLeft(updatedEditorState, marginLeft);
    }
    if (newListType !== "unstyled") {
      // when list is applied handle header to list conversion
      updatedEditorState = handleHeaderToListStyles(
        editorState,
        updatedEditorState,
      );
    }
    this._handleChange(updatedEditorState);
  };

  _highlightSelection = () => {
    const editorState = this._getEditorState();
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    const contentStateWithEntity = currentContent.createEntity(
      "HIGHLIGHT",
      "MUTABLE",
    );

    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const updatedContent = Modifier.applyEntity(
      currentContent,
      selection,
      entityKey,
    );
    this.props.updateEditorHighlightSelection(updatedContent);
  };

  _handlePageNumber = newEditorState => {
    const { activeComponent } = this.props;
    if (
      activeComponent &&
      activeComponent.componentMeta &&
      activeComponent.componentMeta.componentType ===
        DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER
    ) {
      newEditorState = selectAllEditorText(newEditorState);
    }
    return newEditorState;
  };

  _fontFamilyUpdate = (fontStyle, fontValue, fontWeightStyle) => {
    const editorState = this._getEditorState();
    let newEditorState = editorState;

    newEditorState = this._handlePageNumber(newEditorState);

    if (!fontWeightStyle) {
      // if no font weight, get current font weight & find closed one
      const currentInlineStyles = newEditorState.getCurrentInlineStyle();
      if (currentInlineStyles && currentInlineStyles.size > 0) {
        const oldFontWeight = currentInlineStyles.filter(style =>
          style.startsWith("FONTWEIGHT"),
        );
        if (oldFontWeight && oldFontWeight.size > 0) {
          const { newFontWeightStyle } = getClosestFontWeightStyle(
            [...oldFontWeight][0],
            fontStyle,
            fontValue,
          );
          fontWeightStyle = newFontWeightStyle;
        }
      }
    }

    // ADD NEW
    newEditorState = applyFontStyle(newEditorState, fontStyle, "FONTFAMILY");
    if (fontWeightStyle) {
      // remove bold
      const nextContentState = Modifier.removeInlineStyle(
        newEditorState.getCurrentContent(),
        newEditorState.getSelection(),
        "BOLD",
      );
      const selection = newEditorState.getSelection();
      let currentInlineStyle = newEditorState.getCurrentInlineStyle();
      newEditorState = EditorState.push(
        newEditorState,
        nextContentState,
        "change-inline-style",
      );
      if (selection && selection.isCollapsed()) {
        currentInlineStyle = currentInlineStyle.filter(
          style => style && style !== "BOLD",
        );
        newEditorState = EditorState.setInlineStyleOverride(
          newEditorState,
          currentInlineStyle,
        );
      }

      newEditorState = applyFontStyle(
        newEditorState,
        fontWeightStyle,
        "FONTWEIGHT",
      );
    }

    this._handleChange(newEditorState);
  };

  _handleBIUButtonClick = (buttonType, data) => {
    let editorState = this._getEditorState();

    editorState = this._handlePageNumber(editorState);

    /**
     * ####### Update selection for "DYNAMICFIELD" #######
     * here, need to update the selection state
     * if the anchor or focus or both positions have "DYNAMICFIELD",
     * so that if apply styles on one word of DF, it must apply on all words of DF
     */
    const updatedSelectionForEntity = updateSelectionForEntity(
      editorState,
      "DYNAMICFIELD",
    );
    if (updatedSelectionForEntity) {
      const newEditorState = EditorState.acceptSelection(
        editorState,
        updatedSelectionForEntity,
      );
      editorState = newEditorState;
    }
    if (
      buttonType === "FONTSIZE" ||
      buttonType === "FONTCOLOR" ||
      buttonType === "FONTFAMILY" ||
      buttonType === "FONTWEIGHT" ||
      buttonType === "FONTTEXTHIGHLIGHT"
    ) {
      let nextEditorState = editorState;
      // Checking if there is "BOLD" applied, then
      // before applying "FONTWEIGHT", removing the "BOLD"
      if (buttonType === "FONTWEIGHT") {
        const nextContentState = Modifier.removeInlineStyle(
          editorState.getCurrentContent(),
          editorState.getSelection(),
          "BOLD",
        );
        nextEditorState = EditorState.push(
          editorState,
          nextContentState,
          "change-inline-style",
        );
      }

      if (editorState.getSelection().isCollapsed()) {
        nextEditorState = applyFontStyle(nextEditorState, data, buttonType);
      } else {
        nextEditorState = applyFontStyle(nextEditorState, data, buttonType);
      }
      this._handleChange(nextEditorState);
    } else if (buttonType === "BOLD") {
      // handle bold/unbold
      const { newEditorState, newFontWeight } = toggleBold(editorState);
      this._handleChange(newEditorState);
      const metadata = [
        {
          op: "replace",
          field: "meta_data",
          value: {
            meta_data: {
              ...this.props.metaData,
              [buttonType]: newEditorState
                .getCurrentInlineStyle()
                .has(buttonType),
              FONTWEIGHT: newFontWeight,
            },
          },
        },
      ];

      setTimeout(() => {
        this._saveMetaData(metadata);
      }, 10);
    } else {
      // handle other buttons
      const updateES = RichUtils.toggleInlineStyle(editorState, buttonType);
      this._handleChange(updateES);

      const metadata = [
        {
          op: "replace",
          field: "meta_data",
          value: {
            meta_data: {
              ...this.props.metaData,
              [buttonType]: updateES.getCurrentInlineStyle().has(buttonType),
            },
          },
        },
      ];

      setTimeout(() => {
        this._saveMetaData(metadata);
      }, 10);
    }
  };

  _updatedData = (component, components, tableData) => {
    let newSection;
    if (component && component.componentMeta.blockType === "COVERPAGE") {
      const coverpageComponent =
        components[component.componentMeta.coverpageId];
      newSection = {
        ...coverpageComponent.content,
        data: {
          ...coverpageComponent.content.data,
          components: {
            ...coverpageComponent.content.data.components,
            [component.id]: {
              ...coverpageComponent.content.data.components[component.id],
              content: {
                ...component,
                data: tableData,
              },
            },
          },
        },
      };
    } else if (component && component.componentMeta.blockType === "HEADER") {
      const headerComponent = components[component.componentMeta.headerId];
      newSection = {
        ...headerComponent.content,
        data: {
          ...headerComponent.content.data,
          header: {
            ...headerComponent.content.data.header,
            components: {
              ...headerComponent.content.data.header.components,
              [component.id]: {
                ...headerComponent.content.data.header.components[component.id],
                content: {
                  ...component,
                  data: tableData,
                },
              },
            },
          },
        },
      };
    } else if (component && component.componentMeta.blockType === "FOOTER") {
      const footerComponent = components[component.componentMeta.footerId];
      newSection = {
        ...footerComponent.content,
        data: {
          ...footerComponent.content.data,
          footer: {
            ...footerComponent.content.data.footer,
            components: {
              ...footerComponent.content.data.footer.components,
              [component.id]: {
                ...footerComponent.content.data.footer.components[component.id],
                content: {
                  ...component,
                  data: tableData,
                },
              },
            },
          },
        },
      };
    } else if (component && component.componentMeta.blockType === "BODY") {
      newSection = {
        ...component,
        data: tableData,
      };
    }
    return newSection;
  };

  _saveTable = tableData => {
    // const { tableData } = this.state;
    const { readOnly, updateSection, components } = this.props;
    const component = this.props.component || this.state.tempManageColSection;
    let newSection;
    if (!readOnly) {
      newSection = this._updatedData(component, components, tableData);
      this.props.updateDocumentComponentAction(newSection);
      updateSection(newSection, undefined, undefined, component);
    }
  };

  _saveMetaData = data => {
    if (this.props.isEditableTextAreaClauseOptionEditor) {
      this.props.updateDocMeta(data[0].value, true);
    } else {
      if (this.props.mode === "DOCUMENT") {
        this.props
          .updateDocMeta({ docId: this.props.docID, data })
          .then()
          .catch(() => {
            Toastr.showToastr({
              type: "failure",
              message: "Oops, Something went wrong!!",
              timeout: 3000,
            });
          });
      }
      if (this.props.mode === "TEMPLATE") {
        this.props
          .updateTemplateMeta({ docId: this.props.docID, data })
          .then()
          .catch(() => {
            Toastr.showToastr({
              type: "failure",
              message: "Oops, Something went wrong!!",
              timeout: 3000,
            });
          });
      }
    }
  };

  _showHyperlinkBox = (
    tempEditorState,
    tempCurrentSection,
    tempActiveMetaData,
  ) => {
    this.setState({
      showHyperlinkBoxConfirmation: true,
      tempEditorState,
      tempActiveMetaData,
      tempCurrentSection,
    });
  };

  _closeHyperlinkBox = () => {
    this.setState({
      showHyperlinkBoxConfirmation: false,
      tempEditorState: null,
      tempCurrentSection: null,
      tempActiveMetaData: {},
    });
  };

  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  _setMngColsData = (hdnCols, newColHdrs) => {
    const component = this.props.component || this.state.tempManageColSection;
    const { clickedActiveComponentId } = this.props;
    this.setState({
      columnsHeaders: newColHdrs,
      hiddenColumnsForGsheet: hdnCols,
    });
    if (
      component &&
      (component.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET ||
        component.type === DOCUMENT_COMPONENT_TYPES.TABLE ||
        component.data.attributes.showManageColumnOption)
    ) {
      const newSection = {
        ...component,
        data: {
          attributes: {},
          ...component.data,
        },
      };
      newSection.data.attributes.hiddenCols = hdnCols;
      if (
        "columnCount" in newSection.data.attributes &&
        "originalColumnCount" in newSection.data.attributes
      ) {
        newSection.data.attributes.columnCount =
          newSection.data.attributes.originalColumnCount - hdnCols.length;
      }
      this._saveTable(newSection.data, clickedActiveComponentId);
    }
  };

  _addNote = (text, editorState, component, removeHighlightSelection) => {
    const { docID, updateSection } = this.props;
    const note = emptyNote(docID, null);
    note.content = {
      highlight: text,
      message: "",
    };
    const selectionState = editorState.getSelection();
    const blockKeyVal = selectionState.getAnchorKey();
    const anchorKeyVal = selectionState.getAnchorKey();
    const focusKeyVal = selectionState.getFocusKey();
    let acnhorOffsetVal = selectionState.getAnchorOffset();
    let focusOffsetVal = selectionState.getFocusOffset();
    const isBackwardSelection = selectionState.isBackward;
    let selectionDataLength = null;
    if (isBackwardSelection) {
      let tempVar = null;
      tempVar = focusOffsetVal;
      focusOffsetVal = acnhorOffsetVal;
      acnhorOffsetVal = tempVar;
    }
    selectionDataLength = focusOffsetVal - acnhorOffsetVal;
    const noteMappingData = {
      componentId: component.id,
      componentType: component.type,
      blockType: component.componentMeta.blockType,
      selectionData: {
        blockKey: blockKeyVal,
        acnhorOffset: acnhorOffsetVal,
        focusOffset: focusOffsetVal,
        length: selectionDataLength,
        anchorKey: anchorKeyVal,
        focusKey: focusKeyVal,
        // entityData,
      },
      // version: "2",
    };
    if (component.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
      const { tableCellId, tableColId, tableRowId } =
        this.props.activeComponentMeta;
      noteMappingData.tableCellId = tableCellId;
      noteMappingData.tableColId = tableColId;
      noteMappingData.tableRowId = tableRowId;
    }
    note.anchor = {
      component: "DOCUMENT",
      action: "HIGHLIGHT",
      noteMappingConfigs: noteMappingData,
    };
    note.component = component;
    note.editorState = editorState;
    note.updateSection = updateSection;
    note.removeHighlightSelection = removeHighlightSelection;
    note.activeComponentMeta = this.props.activeComponentMeta;
    this.props.addNote(note);
    this.props.changeToolsView("notes");
  };

  // merge-cells flow
  // custom method for merge cells flow
  _saveTableData = (tableData, rowID, colID, change, component) => {
    const { updateSection, readOnly, components } = this.props;

    let editable = false;
    let newSection;
    let oldSection;
    if (rowID !== null && colID !== null) {
      const cellData = getCellData(tableData, rowID, colID);
      if (cellData) {
        const { attributes } = cellData;
        editable = editable || (attributes ? attributes.editable : false);
      }
    }

    if (!readOnly || editable) {
      newSection = this._updatedData(component, components, tableData);
      // Picking oldSection based on blockType
      if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "HEADER"
      ) {
        const headerComponent = components[component.componentMeta.headerId];
        oldSection = { ...headerComponent.content };
      } else if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "FOOTER"
      ) {
        const footerComponent = components[component.componentMeta.footerId];
        oldSection = { ...footerComponent.content };
      } else if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "COVERPAGE"
      ) {
        const coverpageComponent =
          components[component.componentMeta.coverpageId];
        oldSection = { ...coverpageComponent.content };
      } else {
        oldSection = component;
      }
      this.props.updateDocumentComponentAction(newSection);
      updateSection(newSection, change, undefined, oldSection);

      if (
        this.state.tempCurrentActiveComponentMeta &&
        this.state.tempCurrentActiveComponentMeta.tableCellId &&
        this.state.cellContentState
      ) {
        let newCellId = this.state.tempCurrentActiveComponentMeta.tableCellId;
        if (
          tableData.data[rowID].data[colID] &&
          this.state.tempCurrentActiveComponentMeta.tableCellId !==
            tableData.data[rowID].data[colID].attributes.id
        ) {
          newCellId = tableData.data[rowID].data[colID].attributes.id;
        }
        const editorState = EditorState.createWithContent(
          this.state.cellContentState,
          getCompositeDecorator(),
        );
        this.props.initActiveEditor(
          EditorState.moveFocusToEnd(editorState),
          newSection,
          {
            ...this.state.tempCurrentActiveComponentMeta,
            cellSelection: null,
            tableCellEditMode: true,
            selected: null,
            tableColId: colID,
            tableCellId: newCellId,
          },
        );
        this.props.updateComponentMeta({
          ...this.state.tempCurrentActiveComponentMeta,
          cellSelection: null,
          tableCellEditMode: true,
          selected: null,
          tableColId: colID,
          tableCellId: newCellId,
        });

        this.props.updateDocumentClickedComponentID(
          newCellId,
          false,
          this.state.tempCurrentActiveComponentMeta.componentType,
        );
      }
    }
    this._handleMergeCellsPopup(false);
  };

  _emptyCell = () => {
    const cellData = {
      data: {
        data: ContentState.createFromText(""),
        ...emptyTextEditor(this.props.mode, "", true),
      },
      attributes: {
        id: uuid.v4(),
      },
    };
    if (this.props.mode === "DOCUMENT")
      cellData.data.currentContent = ContentState.createFromText("");
    return cellData;
  };

  _mergeCells = () => {
    const {
      tempCurrentSection: component,
      tempCurrentActiveComponentMeta: activeComponentMeta,
    } = this.state;
    if (!component || !activeComponentMeta) {
      return;
    }
    const { data: tableData } = component;

    let activeCell = null;
    let activeCellId = null;

    let focusRowID = null;
    let focusColumnID = null;
    let selectedIndex = null;
    let selectedType = null;
    let cellSelection = null;

    if (activeComponentMeta && Object.keys(activeComponentMeta).length > 0) {
      const {
        tableRowId,
        tableColId,
        componentId,
        tableCellId,
        selected,
        cellSelection: cellSelections,
      } = activeComponentMeta;

      focusRowID = tableRowId !== undefined ? tableRowId : null;
      focusColumnID = tableColId !== undefined ? tableColId : null;

      activeCellId = tableCellId;
      if (selected && Object.keys(selected).length > 0) {
        [selectedIndex, selectedType] = selected;
      }

      activeCell =
        component && component.id === componentId
          ? [tableRowId, tableColId]
          : null;

      cellSelection = cellSelections;
    }

    if (
      activeCell === null ||
      activeCellId === null ||
      focusRowID === null ||
      focusColumnID === null ||
      selectedIndex === null ||
      selectedType === null ||
      selectedType !== "ROW"
    ) {
      this._handleMergeCellsPopup(false);
    }

    const clonedTableData = cloneDeep(tableData);
    const { data: clonedData, attributes } = clonedTableData;
    const activeCellData = clonedData[activeCell[0]].data[activeCell[1]];

    if (cellSelection) {
      // only merge
      const { cols, rows } = activeComponentMeta.cellSelection;
      const selectedRowData = clonedData[rows[0]];

      const sortedIndex = cols.sort();
      const selectionRange = range(sortedIndex[0], sortedIndex[1] + 1);

      selectedRowData.attributes.columnCount -= selectionRange.length - 1;
      // const newColSpan = 0;
      selectedRowData.data = selectedRowData.data
        .map((cell, idx) => {
          if (!selectionRange.includes(idx)) return cell;
          if (idx === selectionRange[0]) {
            let newColSpan = 0;
            selectionRange.forEach(item => {
              if (isTableCellMerged(selectedRowData.data[item])) {
                newColSpan += parseInt(
                  selectedRowData.data[item].attributes.colspan,
                  10,
                );
              } else {
                newColSpan += 1;
              }
            });
            cell.data = selectedRowData.data[this.state.cellDataIndex].data;
            cell.attributes.colspan = newColSpan.toString();
            return cell;
          }
          return null;
        })
        .filter(cell => cell !== null);

      const updatedTableData = {
        data: [...clonedData],
        attributes: {
          ...attributes,
        },
      };
      this._saveTableData(
        updatedTableData,
        focusRowID,
        selectionRange[0],
        true,
        component,
      );
    } else if (
      (isTableCellMerged(activeCellData) && !selectedIndex && !selectedType) ||
      (selectedType === "ROW" && clonedData[activeCell[0]].data.length === 1)
    ) {
      // if condition code is for unmerge
      const colSpanVal = parseInt(activeCellData.attributes.colspan, 10);
      const newCell = { ...activeCellData };
      delete newCell.attributes.colspan;
      const newCells = [];
      newCells.push(newCell);
      for (let i = 0; i < colSpanVal - 1; i += 1) {
        newCells.push(this._emptyCell());
      }
      const currentRowData = clonedData[activeCell[0]].data;

      const newRowData = [
        ...currentRowData.slice(0, activeCell[1]),
        ...newCells,
        ...currentRowData.slice(activeCell[1] + 1),
      ];
      clonedData[activeCell[0]].data = newRowData;
      const updatedTableData = {
        data: [...clonedData],
        attributes: {
          ...attributes,
        },
      };
      this._saveTableData(
        updatedTableData,
        focusRowID,
        focusColumnID,
        true,
        component,
      );
    } else {
      // else condition code is for merge

      const selectedRowData = clonedData[selectedIndex];
      // remove hardcoded 0 index below
      selectedRowData.data = [selectedRowData.data[this.state.cellDataIndex]];
      // Remove hardcoded 1 value with columnCount later
      selectedRowData.attributes.columnCount = 1;
      selectedRowData.data[0].attributes.colspan =
        attributes.columnCount.toString();

      const updatedTableData = {
        data: [...clonedData],
        attributes: {
          ...attributes,
        },
      };

      this.props.tableSelectionTypeAction(null);
      this._saveTableData(
        updatedTableData,
        focusRowID,
        focusColumnID,
        true,
        component,
      );
    }
  };

  _handleMergeCellsPopup = (
    showPopup,
    currentSection,
    currentActiveComponentMeta,
    mergeState,
    cellDataIndex,
    cellContentState,
  ) => {
    const tempCurrentSection = currentSection;
    const tempCurrentActiveComponentMeta = currentActiveComponentMeta;
    this.setState(
      () => ({
        showMergeCellConfirmation: showPopup,
        tempCurrentSection,
        tempCurrentActiveComponentMeta,
        cellDataIndex,
        cellContentState,
      }),
      () => {
        if (mergeState === "unmerge") {
          this._mergeCells("unmerge");
        }
        if (mergeState === "merge" && !showPopup) {
          this._mergeCells();
        }
      },
    );
  };

  // merge-cells flow

  _getComponent = () =>
    this.props.isSeparateToolbar
      ? this.props.activeComponent
      : this.props.section;

  // _getComponent = () => {
  //   const { isSeparateToolbar, activeComponent, section } = this.props;
  //   if (isSeparateToolbar) {
  //     return activeComponent;
  //   }
  //   return section;
  // };

  _showManageColumn = (columnsHeaders, flag, tempManageColSection) => {
    this.setState({
      columnsHeaders,
      showManageColumnPopup: flag,
      tempManageColSection,
    });
  };

  _closeManageColumn = flag => {
    this.setState({
      showManageColumnPopup: flag,
      tempManageColSection: null,
    });
  };

  _isTextEditable = () => {
    const {
      mode,
      activeComponent,
      activeComponentMeta,
      clickedActiveComponentId,
    } = this.props;
    // for internal toolbar case(create clause option editor's toolbar )
    if (!this.props.isSeparateToolbar) return true;

    if (!(clickedActiveComponentId && activeComponentMeta && activeComponent))
      return false;

    if (activeComponentMeta.componentType === DOCUMENT_COMPONENT_TYPES.HTML)
      return true;

    if (activeComponentMeta.componentType === DOCUMENT_COMPONENT_TYPES.TABLE) {
      // check if it a table placeholder
      const { clauseOptions, data: tableData } = activeComponent;
      if (mode === DOCUMENT_MODE.TEMPLATE && clauseOptions && clauseOptions.id)
        return false;

      // check if it is connected to any data source
      if (
        tableData &&
        tableData.attributes &&
        tableData.attributes.isLinkedToDataSource &&
        tableData.attributes.dataSource !== "ExcelTable" &&
        tableData.attributes.dataSource !== "TableApi"
      )
        return false;

      const { tableColId, tableRowId } = activeComponentMeta;
      // check if any cell is active or not
      // if (!(tableColId && tableRowId)) return false;

      let cell;
      if (
        tableData &&
        tableData.data &&
        tableData.data[tableRowId] &&
        tableData.data[tableRowId].data[tableColId]
      ) {
        cell = tableData.data[tableRowId].data[tableColId];
      }

      if (cell) {
        const { attributes } = cell;
        // if any formula is applied to cell, no editing should be allowed
        if (attributes && attributes.appliedFormula) return false;
      }

      return true;
    }
    return true;
  };

  _isCellEditable = () => {
    const {
      clickedActiveComponentId,
      mode,
      activeComponent,
      activeComponentMeta,
    } = this.props;
    if (!(clickedActiveComponentId && activeComponentMeta && activeComponent))
      return false;

    if (activeComponentMeta.componentType !== DOCUMENT_COMPONENT_TYPES.TABLE)
      return false;

    const { clauseOptions, data: tableData } = activeComponent;
    if (mode === DOCUMENT_MODE.TEMPLATE && clauseOptions && clauseOptions.id)
      return false;

    const { attributes } = tableData;

    // if any formula is applied to cell, no editing should be allowed
    if (
      attributes &&
      attributes.isLinkedToDataSource &&
      attributes.dataSource !== "ExcelTable"
    )
      return false;

    return true;
  };

  _handleTableApiEdit = (focusRowID, tableAttributes, direction, type) => {
    const { isUnlinkedTableAPI, dataSource } = tableAttributes;
    if (dataSource !== "TableApi" || !isUnlinkedTableAPI) {
      return false;
    }
    if (type === "COL") {
      this.setState({ showEditHeaderPopupTableApi: true });
      return true;
    }
    if (focusRowID === 0 && (direction === "U" || direction === null)) {
      this.setState({ showEditHeaderPopupTableApi: true });
      return true;
    }
    return false;
  };

  render() {
    const {
      showHyperlinkBoxConfirmation,
      tempCurrentSection,
      tempEditorState,
      showManageColumnPopup,
      showMergeCellConfirmation,
      showEditHeaderPopupTableApi,
    } = this.state;
    const {
      mode,
      updateSection,
      removeHighlightSelection,
      handleUndo,
      handleRedo,
      isSeparateToolbar,
      metaData,
    } = this.props;
    let hyperlinkPopup = null;
    let manageColumnPopup = null;
    let mergeCellPopup = null;
    let showEditTableApiHeader = null;

    const editorState = this._getEditorState();
    const component = this._getComponent();

    if (showHyperlinkBoxConfirmation) {
      hyperlinkPopup = (
        <HyperlinkBox
          mode={mode}
          section={component || tempCurrentSection}
          editorState={editorState || tempEditorState}
          updateSection={updateSection}
          show={showHyperlinkBoxConfirmation}
          closeHyperlinkBox={this._closeHyperlinkBox}
          activeComponentMeta={this.state.tempActiveMetaData}
        />
      );
    }

    if (showManageColumnPopup) {
      manageColumnPopup = (
        <ManageColumnsPopup
          show={this.state.showManageColumnPopup}
          closePopup={() => this._closeManageColumn(false)}
          columns={this.state.columnsHeaders}
          setMngColsData={this._setMngColsData}
          hiddenCols={this.state.hiddenColumnsForGsheet}
          columnDefs={this.props.columnDefs}
          component={component}
        />
      );
    }

    if (showMergeCellConfirmation) {
      mergeCellPopup = (
        <MergeCellConfirmation
          show={this.state.showMergeCellConfirmation}
          closePopup={() => this._handleMergeCellsPopup(false)}
          cellDataIndex={this.state.cellDataIndex}
          mergeCells={this._mergeCells}
        />
      );
    }

    if (showEditHeaderPopupTableApi) {
      showEditTableApiHeader = (
        <EditTableApiHeaderPopup
          closePopup={() => {
            this.setState({ showEditHeaderPopupTableApi: false });
          }}
          header="Are you sure you want edit header row?"
          subHeader={
            "Editing header row might cause some issues in downstream actions. Incase you want to restore the data, click on the restore button in the dropdown."
          }
          checkboxLabel="Yes, I want to edit header row"
          okBtnText="Edit header"
        />
      );
    }

    let className = "";
    if (isSeparateToolbar) {
      className += "customrevvtoolbar-container ";
      if (this.props.showForm) {
        if (this.props.stage === "DRAFT" && !this.props.isSharedDocument) {
          className +=
            " draft-stage-revvtoolbar  textarea-clauseopt-revvtoolbar ";
        }
        if (
          this.props.isSharedDocument &&
          !this.props.isUndoRedoToolbarVisible
        ) {
          className +=
            " textarea-clauseopt-revvtoolbar shared-doc-revvtoolbar ";
        }
        if (
          !this.props.showRevvToolbar ||
          this.props.isUndoRedoToolbarVisible
        ) {
          className += " hidden-revvtoolbar ";
        }

        if (window.innerWidth <= 600) {
          className += " mobile-view-revvtoolbar ";
        }

        if (
          this.props.isEditableTextAreaClauseOptionEditor ||
          this.props.isEditableTablePlaceholderComponent
        ) {
          if (this.props.isSharedDocument) {
            className += " shared-doc-revvtoolbar ";
          }
        }
      }
    }

    return (
      <div className={className} ref={this.props.customToolbarRef}>
        {hyperlinkPopup}
        {manageColumnPopup}
        {mergeCellPopup}
        {showEditTableApiHeader}
        {this.props.showRevvToolbar && !this.props.isUndoRedoToolbarVisible && (
          <Fragment>
            {/* ---------- Text and Table common toolbar ---------- */}
            <Toolbar>
              {externalProps => (
                <RevvToolBar
                  mode={mode}
                  isLocked={this.props.isLocked}
                  externalProps={externalProps}
                  component={component}
                  addNote={this._addNote}
                  editorState={editorState}
                  handleUndo={handleUndo}
                  handleRedo={handleRedo}
                  handlePageNumber={this._handlePageNumber}
                  handleBIUButtonClick={this._handleBIUButtonClick}
                  fontFamilyUpdate={this._fontFamilyUpdate}
                  handleListButton={this._handleListButton}
                  handleHeaderButton={this._handleHeaderButton}
                  handleNormalText={this._setBlockTypeNormal}
                  handleAlignment={this._handleAlignmentLineHeight}
                  handleLineHeight={this._handleAlignmentLineHeight}
                  handleIndent={this._handleIndent}
                  highlightSelection={this._highlightSelection}
                  removeHighlightSelection={removeHighlightSelection}
                  showHyperlinkBox={this._showHyperlinkBox}
                  closeHyperlinkBox={this._closeHyperlinkBox}
                  showForm={this.props.showForm}
                  isSeparateToolbar={isSeparateToolbar}
                  preventEditorToDeactivate={
                    this.props.preventEditorToDeactivate
                  }
                  handleCustomColorDropDownOpen={
                    this.props.handleCustomColorDropDownOpen
                  }
                  toolbarCustomColorDropdownRef={
                    this.props.toolbarCustomColorDropdownRef
                  }
                  metaData={metaData}
                  saveMetaData={this._saveMetaData}
                  isEditableTextAreaClauseOptionEditor={
                    this.props.isEditableTextAreaClauseOptionEditor
                  }
                  isEditableTablePlaceholderComponent={
                    this.props.isEditableTablePlaceholderComponent
                  }
                  formOpen={this.props.formOpen}
                  activeToolbarDropDown={this.state.activeToolbarDropDown}
                  toogleToolbarDropDown={this._toogleToolbarDropDown}
                  activeComponentMeta={this.props.activeComponentMeta}
                  isTextEditable={this._isTextEditable()}
                  clickedActiveComponentId={this.props.clickedActiveComponentId}
                  handleChange={this._handleChange}
                  isSharedDocument={this.props.isSharedDocument}
                />
              )}
            </Toolbar>

            {/* ----------Table options toolbar ---------- */}
            <RevvTableToolBar
              mode={mode}
              component={component}
              editorState={editorState}
              updateSection={this.props.updateSection}
              isSeparateToolbar={isSeparateToolbar}
              preventEditorToDeactivate={this.props.preventEditorToDeactivate}
              metaData={metaData}
              saveMetaData={this._saveMetaData}
              showManageColumn={this._showManageColumn}
              updateState={this._updateMultipleState}
              updatedData={this._updatedData}
              activeToolbarDropDown={this.state.activeToolbarDropDown}
              toogleToolbarDropDown={this._toogleToolbarDropDown}
              showForm={this.props.showForm}
              isEditableTablePlaceholderComponent={
                this.props.isEditableTablePlaceholderComponent
              }
              isCellEditable={this._isCellEditable()}
              handleMergeCellsPopup={this._handleMergeCellsPopup}
              mergeCells={this._mergeCells}
              clickedActiveComponentId={this.props.clickedActiveComponentId}
              handleTableApiEdit={this._handleTableApiEdit}
              saveUnlinkedTableAPICellData={this._saveUnlinkedTableAPICellData}
              activeComponentMeta={this.props.activeComponentMeta}
              getEditorState={this._getEditorState}
              activeComponent={this.props.activeComponent}
              section={this.props.section}
            />
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { activeEditorState, activeComponent: editorStoreActiveComponent } =
    state.EditorStore;
  const {
    components,
    activeComponentMeta,
    clickedActiveComponentId,
    docRecipientList,
    document: {
      meta_data: docMetaData,
      fields_used: usedFormFields,
      showForm,
      stage,
      isLocked,
      docType,
      scope: { write, fill } = {},
    },
    acceptorsList,
    tables: tablesUsed,
  } = state.DocumentStore;
  const { recipientType } = state.SharedDocument;

  const {
    template: { meta_data: tempMetaData },
  } = state.TemplateStore;

  const { dealTableId } = state.QuotationStore;
  const { columnDefs: { [dealTableId]: columnDefs } = [] } =
    state.DealTableStore;

  let metaData;

  let isEditableTextAreaClauseOptionEditor = false;
  let isEditableTablePlaceholderComponent = false;

  let showRevvToolbar = true;
  let clauseOptionsDetails = null;

  let activeComponent = editorStoreActiveComponent;
  if (
    !activeComponent &&
    activeComponentMeta &&
    activeComponentMeta.componentType === "Table"
  ) {
    activeComponent = getComponentFromInfo(components, activeComponentMeta);
  }

  if (props.mode === "DOCUMENT") {
    metaData = docMetaData;

    // If the section has a editable "text area" clause option, then
    // show the toolbar
    if (activeComponent && activeComponent.clauseOptions && usedFormFields) {
      clauseOptionsDetails = usedFormFields.find(
        clause => clause.id === activeComponent.clauseOptions.id,
      );
      if (clauseOptionsDetails) {
        if (activeComponent.type === "HTML") {
          isEditableTextAreaClauseOptionEditor = isEditableTextAreaCOEditor(
            props.mode,
            state.DocumentStore.document,
            docRecipientList,
            props.isSharedDocument,
            clauseOptionsDetails,
          );
          // showRevvToolbar = isEditableTextAreaClauseOptionEditor;
        }

        if (activeComponent.type === "Table") {
          isEditableTablePlaceholderComponent = isEditableRevvComponent(
            activeComponent.type,
            props.mode,
            state.DocumentStore.document,
            docRecipientList,
            props.isSharedDocument,
            clauseOptionsDetails,
          );
          showRevvToolbar = isEditableTablePlaceholderComponent;
        }
      }
    }
  }

  if (props.mode === "TEMPLATE") {
    metaData = tempMetaData;
    const {
      template: { status },
    } = state.TemplateStore;
    if (status !== "DRAFT") showRevvToolbar = false;
  }

  // To handle toolbar in form mode
  let isUndoRedoToolbarVisible = isLocked;
  if (showForm) {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    // For internal user
    const currentUserIsFiller = docRecipientList.some(
      item =>
        item.user &&
        item.user.id === (CURRENT_USER && CURRENT_USER.id) &&
        item.recipient_type === "FILLER",
    );
    const currentAcceptorIsFiller = acceptorsList.some(
      item =>
        item.user &&
        item.user.id === (CURRENT_USER && CURRENT_USER.id) &&
        item.recipient_type === "FILLER",
    );

    let lockedInStage = true;
    if (
      docType === "master_form" &&
      (recipientType === "" || recipientType === null)
    ) {
      lockedInStage = true;
    } else if (
      stage === "DRAFT" ||
      (stage === "SENT_FOR_FILLING" &&
        (recipientType === "FILLER" ||
          currentUserIsFiller ||
          currentAcceptorIsFiller))
    ) {
      lockedInStage = false;
    }

    isUndoRedoToolbarVisible = (isLocked && !(write || fill)) || lockedInStage;
  }

  return {
    activeComponentMeta,
    metaData,
    showRevvToolbar,
    isEditableTextAreaClauseOptionEditor,
    isEditableTablePlaceholderComponent,
    showForm,
    stage,
    clauseOptionsDetails,
    clickedActiveComponentId,
    components,
    isUndoRedoToolbarVisible,
    // Editor Store
    activeEditorState,
    activeComponent,
    columnDefs,
    tablesUsed,
  };
};

const mapDispatchToProps = {
  addNote,
  changeToolsView,
  preventEditorToDeactivate,
  handleCustomColorDropDownOpen,
  updateEditorHighlightSelection,
  updateDocMeta,
  updateTemplateMeta,
  updateComponentEditorState,
  executeCommand,
  updateDynamicFieldsInDoc,
  updateDynamicFieldsInMasterDoc,
  updateDocumentComponentAction,
  updateComponentMeta,
  updateEditorStateInSectionForClauseOptions,
  updateDocumentClickedComponentID,
  tableSelectionTypeAction,
  updateTableAPICellData,
  updateTableAPIColData,

  // Editor store related actions
  updateActiveEditorState,
  forceUpdateLocalEditorState,
  initActiveEditor,
  nukeActiveEditor,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomRevvToolbar);
